import main from './fa/main.json';
import property from './fa/property.json';
import type from './fa/property.types.json';
import deal_type from './fa/property.deal_types.json';
import property_attribute from './fa/property_attribute';
import property_deed from './fa/property_deed';
import property_cabinet from './fa/property_cabinet';
import property_business_permit from './fa/property_business_permit';
import property_construction_permit from './fa/property_construction_permit';
import property_density from './fa/property_density';
import property_floor from './fa/property_floor';
import property_flooring from './fa/property_flooring';
import property_front from './fa/property_front';
import property_instruction_phase from './fa/property_instruction_phase';
import property_position from './fa/property_position';


export default {
    main,
    property,
    type,
    deal_type,
    property_attribute,
    property_deed,
    property_cabinet,
    property_business_permit,
    property_construction_permit,
    property_density,
    property_floor,
    property_flooring,
    property_front,
    property_instruction_phase,
    property_position,
};
